import React, { useState } from "react";
import { Icon, Modal, IconButton } from "@fluentui/react";
import styles from "./Notifications.module.css";

interface NotificationsProps {
    className?: string;
    labelClassName?: string;
}

const Notifications: React.FC<NotificationsProps> = ({ className, labelClassName }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    return (
        <>
            <button 
                className={className || styles.notificationButton}
                onClick={openModal}
                aria-label="Notificaciones"
            >
                <Icon iconName="Ringer" />
                <span className={labelClassName || styles.buttonText}>Notificaciones</span>
            </button>

            <Modal
                isOpen={isModalOpen}
                onDismiss={closeModal}
                isBlocking={false}
                containerClassName={styles.modalContainer}
                styles={{
                    main: {
                        background: 'transparent',
                        border: 'none',
                        boxShadow: 'none',
                        borderRadius: '16px',
                    },
                    root: {
                        background: 'transparent',
                    },
                    scrollableContent: {
                        background: 'transparent',
                        border: 'none',
                        outline: 'none',
                    }
                }}
            >
                <div className={styles.modalContent}>
                    <div className={styles.modalHeader}>
                        <h2 className={styles.modalTitle}>Notificaciones</h2>
                        <div className={styles.headerActions}>
                            <IconButton
                                iconProps={{ iconName: "More" }}
                                className={styles.moreButton}
                                ariaLabel="More options"
                            />
                            <IconButton
                                iconProps={{ iconName: "Cancel" }}
                                onClick={closeModal}
                                className={styles.closeButton}
                                ariaLabel="Close"
                            />
                        </div>
                    </div>
                    
                    <div className={styles.modalBody}>
                        <div className={styles.emptyState}>
                            <Icon iconName="Mail" className={styles.emptyIcon} />
                            <p className={styles.emptyText}>Tus notificaciones aparecerán aquí</p>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default Notifications;